import {observer} from "mobx-react-lite";
import * as React from "react";
import {useEffect} from "react";
import {createTrack, deleteTrack as deleteTrackItem, getTracks, updateTrack, findTracks} from "../http/trackApi";
// import {getContract} from "../http/contractApi";
import {REPORTS_ROUTE, TRACKS_ROUTE} from "../utils/constants";
import {createContract, deleteContract, getContracts, updateContract} from "../http/contractApi";
import Contracts from "./Contracts";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import Divider from "@mui/material/Divider";
import {Grid, SvgIcon} from "@mui/material";
import TrackFields from "../components/contract/TrackFields";
import TrackSearch from "../components/contract/TrackSearch";
import {DataGrid, gridClasses} from "@mui/x-data-grid";
import {useNavigate} from "react-router-dom";




const renderVariations = (params)=>{
    console.log(params);
    // list, type='artist'
    let result = [];

    let list = params.row.variations;
    let count = 0;
    for (const listKey in list) {
        count++;
        const {title, track} = list[listKey];
        if(count < 4){
            result.push(<div style={{whiteSpace: "nowrap"}}>
                <>{result.length ? <><br /></> : null}</>
                <>{`${title} - ${track}`}</>
            </div>);
        }
        if(count === 4){
            result.push(<div style={{whiteSpace: "nowrap"}}>
                <>...</>
            </div>);
        }
    }

    return result;
}

const columns = [
    // {
    //   field: "id",
    //   headerName: "ID",
    //   width: 90,
    //   editable: false,
    //   sortable: true,
    // },
    {
        field: "id",
        headerName: "id",
        width: 150,
        editable: false,
        sortable: true,
        flex: 0,
        minWidth: 30,
    },
    {
        field: "title",
        headerName: "Артист",
        width: 250,
        editable: false,
        sortable: true,
        flex: 0,
        minWidth: 250,
    },
    {
        field: "track",
        headerName: "Трек",
        width: 250,
        editable: false,
        sortable: true,
        flex: 0,
        minWidth: 250,
    },
    {
        field: "variations",
        headerName: "Написания",
        width: 150,
        editable: false,
        sortable: true,
        flex: 1,
        minWidth: 150,
        renderCell: renderVariations
    },
];

const Tracks = observer(() => {
    const [data, setData] = React.useState([]);
    const [editId, setEditId] = React.useState(0);
    const [showForm, setShowForm] = React.useState(false);
    const [searchForm, setSearchForm] = React.useState({
        song: '',
        title: ''
    });
    const navigate = useNavigate();
    const [form, setForm] = React.useState({
        title: "",
        track: "",
        variations: []
    });


    const onDelete = async ()=>{
        console.log(editId);
        if(window.confirm("Точно удалить трек?")) {
            await deleteTrackItem(editId);
            await getList();
            setForm({
                title: "",
                track: "",
                variations: []
            })
            setShowForm(false);
            setEditId(0);
        }
    }

    const onAddTrack = async ()=>{
        try {
            // console.log(user.getId());
            const response = await createTrack({...form});
            await getList();
            setForm({
                title: "",
                track: "",
                variations: []
            })
            setEditId(0);
        } catch (error) {
            console.log(error);
        }
    }
    const onEditTrack = async ()=>{
        try {
            const response = await updateTrack(editId, {...form});
            console.log(form);
            await getList();
            setForm({
                title: "",
                track: "",
                variations: []
            })
            setEditId(0);
        } catch (error) {
            console.log(error);
        }
    }

    const onSubmit = async ()=>{
        console.log(form);
        if(editId){
            await onEditTrack();
            setShowForm(false);
        } else {
            await onAddTrack();
            setShowForm(false);
        }
    }

    const rowClick = ({row})=>{
        if(row?.id){
            console.log(row);
            setEditId(row.id);
            setForm({
                title: row.title,
                track: row.track,
                variations: row.variations
            });
            setShowForm(true);
        }

    }

    const addTrack = (e) => {
        e.preventDefault();

        setForm(prevState => {
            return {
                ...prevState,
                ['variations']: prevState.variations ? [...prevState.variations, {title: '', track: ''}] : [{title: '', track: ''}]
            }
        });
    }

    const trackChange = (e, id)=>{
        setForm(prevState => {
            let result = {...prevState};
            result["variations"][id] = {...result["variations"][id], [e.target.name]: e.target.value}
            return result
        });


        // ({ ..., ["track"]: e.target.value }));
    }

    const deleteTrack = (id) => {
        let result = [];
        for (const tracksKey in form.variations) {
            let item = form.variations[tracksKey];
            if(parseInt(tracksKey) !== parseInt(id)){
                result.push(item);
            }
        }
        setForm({
            ...form,
            variations: result,
        });
    }

    const formChange = (e, newVal, test) => {
        if(e.target.type === "checkbox") {
            setForm(prevState => ({ ...prevState, [e.target.name]: e.target.checked }));
        } else if(newVal && e.target.type === "button" ) {
            let name = e.target.parentNode.getAttribute("name");
            setForm(prevState => ({...prevState, [name]: newVal + ""}));
        } else {
            setForm(prevState => ({...prevState, [e.target.name]: e.target.value}));
        }
    }

    let getList = async ()=>{
        let data = await getTracks();
        setData(data);
    }

    useEffect(()=>{
        (async ()=>{
            await getList();
        })();
    },[])

    const onAddVariation = (info)=>{
        // console.log(info);
        setForm(prevState => ({
            ...prevState,
            variations: [
                ...prevState.variations,
                {
                    title: info.singer,
                    track: info.songName
                }
            ]
        }));
    }

    console.log(form);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            }}
        >
            <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                justifyContent="flex-end"
                width={'100%'}
                p={2}
            >
                <Button
                    color="secondary"
                    variant="outlined"
                    onClick={() => {
                        setEditId(0);
                        setShowForm(true);
                    }}
                >Создать трек</Button>
            </Box>
            <Box sx={{ height: "100%", width: "100%" }}>
                <DataGrid
                    rows={data}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    getRowHeight={() => 'auto'}
                    sx={{
                        [`& .${gridClasses.cell}`]: {
                            py: 1,
                        },
                    }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    disableRowSelectionOnClick
                    onRowClick={rowClick}
                />
            </Box>
            <Dialog
                open={showForm}
                onClose={() => {
                    setShowForm(false);
                    setEditId(0);
                }}
                fullWidth={true}
                maxWidth={"sm"}
                my={4}
                gap={4}
                p={2}
                sx={{border: "2px solid grey"}}
            >
                <Box
                    p={2}
                >
                    <Typography variant="h4" gutterBottom>
                        {editId ? "Редактирование трека" : "Создание трека"}
                    </Typography>
                </Box>
                <Box
                    width={"100%"}
                    p={2}
                    rowGap={2}
                    display="flex"
                    flexDirection="column"
                >
                    <TextField
                        className="login__page__item"
                        label="Артист"
                        variant="outlined"
                        color="secondary"
                        name={'title'}
                        value={form['title']}
                        onChange={formChange}
                    />
                    <TextField
                        className="login__page__item"
                        label="Трек"
                        variant="outlined"
                        color="secondary"
                        name={'track'}
                        value={form['track']}
                        onChange={formChange}
                    />
                    {/*<TextField*/}
                    {/*    className="login__page__item"*/}
                    {/*    label="Написания"*/}
                    {/*    variant="outlined"*/}
                    {/*    color="secondary"*/}
                    {/*    name={'variations'}*/}
                    {/*    value={form['variations']}*/}
                    {/*    onChange={formChange}*/}
                    {/*/>*/}
                    <Grid
                        container
                        // display={'flex'}
                        justifyContent={'space-between'}
                        sx={{
                            marginTop: 1,
                            marginBottom: 1
                        }}
                        spacing={2}
                    >
                        <Grid item>
                            <Typography variant="h5" gutterBottom>Написания</Typography>
                        </Grid>
                        <Grid item>
                            <SvgIcon
                                color="secondary"
                                onClick={addTrack}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ff6000">
                                    <path d="M0 0h24v24H0V0z" fill="none"/>
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/>
                                </svg>
                            </SvgIcon>
                        </Grid>
                    </Grid>
                    <TrackSearch
                        onAddTrack={onAddVariation}
                        variations={form.variations}
                    />
                    {
                        form.variations && form.variations.length ? form.variations.map((track, index)=>
                            <TrackFields
                                key={'var_' + index}
                                artist={track.title}
                                title={track.track}
                                artistName={"title"}
                                trackName={"track"}
                                onChange={(e)=>{trackChange(e,index)}}
                                onDelete={()=>{deleteTrack(index)}}
                            />
                        ) : null
                    }
                </Box>

                <Box
                    p={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    gap={4}
                >
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={()=>{
                            setForm({
                                title: "",
                                track: "",
                                variations: []
                            });
                            setEditId(0);
                            setShowForm(false);
                        }}
                    >
                        Отмена
                    </Button>
                    {editId ?
                        <Button
                            variant="contained"
                            color="error"
                            onClick={onDelete}
                        >
                            Удалить
                        </Button>: null
                    }
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={onSubmit}
                    >
                        {editId ? "Обновить трек" : "Добавить трек"}

                    </Button>
                </Box>
            </Dialog>
        </div>
    )
});

export default Tracks;